export default {
  path: '/patient',
  component: () => import('../../views/patient/patient-router.vue'),
  children: [
    {
      path: '',
      name: 'Patient',
      component: () => import('../../views/patient/pages/Patient.vue'),
      meta: {
        name: 'navigationDrawer.patient',
        icon: '/icons/queuepage.svg',
        auth: true
      }
    },
    {
      path: 'patient-detail/:id',
      name: 'PatientDetail',
      component: () => import('../../views/patient/pages/PatientDetail/PatientDetail.vue'),
      meta: {
        name: 'navigationDrawer.patient',
        icon: '/icons/queuepage.svg',
        auth: true
      }
    },
    {
      path: 'patient-create',
      name: 'PatientCreate',
      component: () => import('../../views/patient/pages/PatientCreate.vue'),
      meta: {
        name: 'navigationDrawer.patient',
        icon: '/icons/queuepage.svg',
        auth: true
      }
    },
    {
      path: 'patient-edit/:id',
      name: 'PatientEdit',
      component: () => import('../../views/patient/pages/PatientEdit.vue'),
      meta: {
        name: 'navigationDrawer.patient',
        icon: '/icons/queuepage.svg',
        auth: true
      }
    }
  ]
}
